import ApiService from './ApiService'

export const A4AService = {

  baseURL: process.env.VUE_APP_A4A_URL,

  getAllAvailableTests() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v1/tests/admin/all`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })

  }

}


